/* eslint-disable react-native/no-inline-styles */
// Created by Hieu Manh
import * as React from "react";
import { FlatList, useWindowDimensions } from "react-native";
import { Button, useTheme } from "react-native-paper";
import { spacing } from "@styles/spacing";
import { useDesktopMediaQuery } from "@media-query";
import { Block } from "@block";
import { testProps } from "app/shared/util/test-props";
import { ItemCompleteProps } from "../../modal/auto-complete/auto-complete";

interface InputSegmentProps {
  control?: any;
  name?: string;
  label?: string;
  values: ItemCompleteProps[];
  onSelected: (item: ItemCompleteProps) => void;
}

export const InputGridListView = (props: InputSegmentProps) => {
  const { values = [], onSelected = () => {} } = props;
  const isDesktop = useDesktopMediaQuery();
  const { colors } = useTheme();
  const { width } = useWindowDimensions();
  const [selected, setItemSelected] = React.useState({ value: "", label: "" });

  const onPressItem = (item: ItemCompleteProps) => {
    setItemSelected(item);
    onSelected(item);
  };

  return (
    <Block>
      <FlatList
        contentContainerStyle={{ flex: 1 }}
        data={values}
        numColumns={isDesktop && width > 1095 ? 4 : width > 388 ? 3 : width > 288 ? 2 : 1}
        key={isDesktop && width > 1095 ? "4" : width > 388 ? "3" : width > 288 ? "2" : "1"}
        keyExtractor={(item) => String(item.value)}
        renderItem={({ item }) => (
          <Block style={{ maxWidth: isDesktop && width > 1095 ? "25%" : width > 388 ? "33.33%" : width > 288 ? "50%" : "100%" }} flex={1}>
            <Button
              key={item.value}
              onPress={() => onPressItem(item)}
              style={{ marginHorizontal: spacing.small, marginBottom: spacing.medium }}
              mode="contained"
              color={selected.value === item.value ? colors.accent : colors.deselect}
              labelStyle={{
                fontWeight: "700",
                alignSelf: "center",
                color: selected.value === item.value ? colors.surface : colors.accent,
                fontSize: width > 420 ? 14 : 11,
              }}
              {...testProps(item.label)}>
              {item.label}
            </Button>
          </Block>
        )}
      />
    </Block>
  );
};
